<template>
    <footer class="footer has-background-black" :class="{'is-hidden': !navVis}">
      <div class="container">
        <div class="columns">
          <div class="column is-uppercase">
            <h3 class="title is-4">Services</h3>
            <ul>
              <li><router-link to="/sell-with-us">Sell with us</router-link></li>
              <li><router-link to="/for-agents">For Agents</router-link></li>
              <li><router-link to="/nestegg-downloads">NestEgg Downloads</router-link></li>
            </ul>
          </div>

          <div class="column is-uppercase">
            <h3 class="title is-4">About</h3>
            <ul>
              <li><router-link to="/about-us">About NestEgg</router-link></li>
              <li><router-link to="/faqs">Read our FAQs</router-link></li>
            </ul>
          </div>

          <div class="column is-uppercase">
            <h3 class="title is-4">Legals</h3>
            <ul>
              <li><router-link to="terms-of-use">Terms of Use</router-link></li>
              <li><router-link to="privacy-policy">Privacy Policy</router-link></li>
            </ul>
          </div>

          <div class="column">
            <img class="unpadded" src="../assets/images/ne_footer_logo.svg">
            <p class="subtitle is-7 has-text-weight-semibold">Journey Business Solutions (Pty) Ltd, Trading as “NestEgg”, Reg. No. 2015/171983/07</p>
            <p class="subtitle is-7 has-text-weight-semibold">4 Oakdale Road, Newlands, Cape Town, 7700</p>
            <div class="is-flex">
              <router-link to="/contact-us">
                <img class="footer-icon" src="../assets/images/contact_icon.svg">
              </router-link>
              <a href="https://www.facebook.com/Mynesteggsa/">
                <img class="footer-icon" src="../assets/images/fb_icon.svg">
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
</template>

<script>
  export default {
    props: {
      navVis: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="scss">
  .footer-icon {
    width: 1.5em;
    margin-right: 0.5em;
  }

  footer li a {
    font-size: 0.9em;
    color: white !important;
  }
</style>